import { useEffect, useRef, useState } from 'react';

export enum OddsChange {
    None,
    Increased,
    Decreased
}

export const useOddsChange = (odds: number, betId = '', duration = 1000): OddsChange => {
    const previousOdds = useRef(odds);
    const previousMarketId = useRef(betId);
    const [state, setState] = useState<OddsChange>(OddsChange.None);
    useEffect(() => {
        if (betId !== previousMarketId.current) {
            previousMarketId.current = betId;
            previousOdds.current = odds;
            return;
        }
        if (odds !== previousOdds.current) {
            setState(odds > previousOdds.current ? OddsChange.Increased : OddsChange.Decreased);
            previousOdds.current = odds;
            const timeout = setTimeout(() => setState(OddsChange.None), duration);
            return () => {
                clearTimeout(timeout);
                setState(OddsChange.None);
            };
        }
    }, [odds, duration, betId]);
    return state;
};
